import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Studio from "@/pages/Studio";
import SharedTab from "@/pages/SharedTab";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import JoinTeam from "@/pages/JoinTeam";
import AuthCallback from "@/pages/AuthCallback";
import PracticePack from "@/pages/PracticePack";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Studio />} />
      <Route path="/t/:id" element={<SharedTab />} />
      <Route path="/p/:id" element={<PracticePack />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/join/:token" element={<JoinTeam />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App dark">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#12161f",
              border: "1px solid rgba(0,240,255,0.2)",
              color: "#f0f6fc",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
